export default function getSegmentId(labelStack) {
  for (var i = labelStack.length - 1; i >= 0; i--) {
    var label = labelStack[i];
    if ('segmentId' in label) {
      return label.segmentId;
    }
  }
  return undefined;
}